import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 30px;
  align-items: center;
  flex: 1;
`

export default function Loader() {
  return (
    <Wrapper>
      <span>Carregando...</span>
    </Wrapper>
  )
}
